import * as moment from 'moment';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {ConfirmationDialogComponent} from './confirmation-dialog/confirmation-dialog.component';
import {EditDetailsFormComponent} from './edit-details-form/edit-details-form.component';
import {MatDialog, MatSnackBar, MatTableDataSource} from '@angular/material';
import {ToastMessagesService} from '../services/toast-messages.service';
import {environment} from '../../environments/environment';

@Component({
  styleUrls: ['./repair-details.component.scss'],
  templateUrl: './repair-details.component.html'
})
export class RepairDetailsComponent implements OnInit {
  private repairId: number;
  public repairInfo: RepairInfo;
  public dataSource: MatTableDataSource<Details>;
  public damagesDataSource = new MatTableDataSource<Damage>();
  public specialDamagesDataSource = new MatTableDataSource<SpecialDamage>();
  public sparePartsDataSource = new MatTableDataSource<SpareParts>();
  public displayedColumns: string[] = ['serial_number', 'material_id', 'material_description', 'refrigerator_type_description', 'product_status_description', 'temperature', 'comments', 'repair_date', 'actions'];
  public damagesDisplayedColumns: string[] = ['repair_details_damage_id', 'description'];
  public specialDamagesDisplayedColumns: string[] = ['repair_details_special_damage_id', 'description'];
  public sparePartsDisplayedColumns: string[] = ['category_description', 'description', 'measurement_unit', 'quantity'];
  public canShowInfo: boolean;
  public showExtraInfo: boolean;
  public loadingImages: boolean;
  public imageFileSource: string[];
  public imageRepairFileSource: string[];
  public technicians: any;
  public selectedTechnician: any;
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  private user: any;
  public repairedInfo: any;
  public selectedRow: any;
  public title: string;

  constructor(private activatedRoute: ActivatedRoute,
              public authService: AuthService,
              private commonService: CommonService,
              private matDialog: MatDialog,
              private matSnackBar: MatSnackBar,
              private router: Router,
              private toastMessagesService: ToastMessagesService) {
  }

  public ngOnInit(): void {
    this.canShowInfo = false;
    this.showExtraInfo = false;
    this.loadingImages = false;
    this.imageFileSource = [];
    this.imageRepairFileSource = [];
    this.activatedRoute.params.subscribe(async (params) => {
      this.repairId = params.id;
      this.getRepairInfo(params.id).then(async response => {
        this.repairInfo = response;

        this.title = this.repairInfo.type_id === 3 ? 'Πληροφορίες εντολής επισκευής' : 'Πληροφορίες εντολής συντήρησης';
        this.dataSource = new MatTableDataSource<Details>();
        this.dataSource.data = this.repairInfo.details;
        if (this.repairInfo.status_id === 4 || this.repairInfo.type_id !== 3) {
          const removeIndex = this.displayedColumns.length - 1;
          this.displayedColumns = this.displayedColumns = ['serial_number', 'material_id', 'material_description', 'refrigerator_type_description', 'product_status_description', 'temperature', 'comments', 'repair_date'];
        } else {
          this.displayedColumns = ['serial_number', 'material_id', 'material_description', 'refrigerator_type_description', 'product_status_description', 'temperature', 'comments', 'repair_date', 'actions'];
        }

        this.technicians = await this.getTechnicians(this.repairInfo.distribution_center_id, this.repairInfo.type_id, this.repairInfo.category_type);

        if (this.repairInfo.expected_date === null) {
          this.repairInfo.expectedDateToString = '-';
        } else {
          this.repairInfo.expectedDateToString = moment(this.repairInfo.expected_date).format('DD-MM-YYYY');
        }

        if (this.repairInfo.last_save === null) {
          this.repairInfo.lastSave = '-';
        } else {
          this.repairInfo.lastSave = moment(this.repairInfo.last_save).format('DD-MM-YYYY');
        }

        // if (isNaN(tempDate.getTime())) {
        //   this.repairInfo.expectedDateToString = '';
        // } else {
        //   this.repairInfo.expectedDateToString = moment(this.repairInfo.expected_date).format('DD-MM-YYYY');
        // }


        this.canShowInfo = true;
        this.showBasicInfo = false;
        this.initUser();
      });

    });
  }

  private async initUser() {
    this.user = await this.authService.getUser();
    this.initBasicInfo();
  }

  private async initBasicInfo() {
    this.basicDetailsConfig = {
      subtitle: [
        {
          title: 'Αριθμός Εντολής',
          value: this.repairInfo.id
        }
      ],
      title: this.title
    };

    this.initializeActions();
  }

  private async initializeActions() {
    const toolTip = 'Η εντολή είναι ήδη ολοκληρωμένη';
    const actions = [];

    const action1 = {
      function: () => {
        this.editExpectedDate();
      },
      showAction: this.canShowEditDate(true),
      title: 'Ενημέρωση Προγραμματισμένης Ημερομηνίας',
      icon: 'event',
      color: '#013e81',
      tooltip: toolTip
    };

    const action2 = {
      function: () => {
        this.editRouting();
      },
      showAction: this.canShowEditDate(true),
      title: 'Ενημέρωση ανάθεσης',
      icon: 'directions',
      color: '#013e81',
      tooltip: toolTip
    };

    const action3 = {
      function: () => {
        this.completeOrder();
      },
      showAction: this.canShowEditDate(),
      title: 'Ολοκλήρωση Εντολής',
      icon: 'done',
      color: 'green',
      tooltip: toolTip
    };

    const action4 = {
      function: () => {
        this.exportToPdf();
      },
      showAction: true,
      title: 'Προεπισκόπηση Εκτύπωσης',
      icon: 'remove_red_eye',
      color: '#013e81',
      tooltip: toolTip
    };

    const actionCancel = {
      function: () => {
        this.initializeConfirmCancellationDialog(this.repairInfo);
      },
      showAction: this.repairInfo.status_id === 11,
      title: 'Διαγραφή Εντολής',
      icon: 'cancel',
      color: 'red'
    };


    if (this.user.role_alternate_name === 'callCenterManager' || this.user.role_alternate_name === 'hqManager') {
      actions.push(action4);
    } else if (this.user.role_alternate_name === 'technicalManager' && this.user.is_internal === 0) {
      actions.push(action2);
      actions.push(action1);
      actions.push(action4);
    } else if (this.user.role_alternate_name === 'technicalManagerNew') {
      actions.push(action3);
      actions.push(action2);
      actions.push(action1);
      actions.push(action4);
    } else {
      actions.push(action3);
      actions.push(action2);
      actions.push(action1);
      actions.push(action4);
      actions.push(actionCancel);
    }


    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = await this.commonService.showActions(this.user) && this.repairInfo.status_id !== 9;
    } else {
      this.basicDetailsConfig.showActions = false;
    }
    this.showBasicInfo = true;
  }

  private async initializeConfirmCancellationDialog(details) {
    const cancellationDialog = this.matDialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να διαγράψετε την εντολή  με αριθμό ${details.id}?`,
        title: 'Διαγραφή εντολής'
      }
    });

    cancellationDialog.afterClosed().subscribe(async (response) => {
      if (response) {
        await this.cancelRequest(details);
      }
    });
  }

  private async cancelRequest(details) {
    try {

      await this.commonService.deleteItem(`repair/web`, details.id);

      this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
      if (this.repairInfo.type_id === 1) {
        await this.router.navigate(['maintenance']);
      } else {
        await this.router.navigate(['repairs']);
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  private canShowEditDate(access?: boolean): boolean {
    if (access) {
      return this.repairInfo.status_id !== 4;
    } else {
      return this.repairInfo.status_id !== 4 && this.authService.isUserInternal();
    }
  }


  public exportToPdf() {
    this.router.navigate(['pdfSample', this.repairId]);
  }

  private async completeOrder() {
    try {
      await this.commonService.updateObject(`repair/web/${this.repairId}`, {change_type: 'complete'});
      this.openSnackBar('Η εντολή ολοκληρώθηκε με επιτυχία');
      if (this.repairInfo.type_id === 1 || this.repairInfo.type_id === 2) {
        await this.router.navigate(['maintenance']);
      } else {
        await this.router.navigate(['repairs']);
      }
      // this.dialog.open(ActionCompletionDialogComponent, {
      //   data: {
      //     buttonText: 'Πλοήγηση στις εντολές συντήρησης',
      //     redirectURL: `maintenance`
      //   }
      // });
    } catch (e) {
      this.openSnackBar('Κάτι πήγε στραβά. ' + e.message);
    }
  }

  async getRepairInfo(id: number) {
    try {
      return await this.commonService.getSimpleList(`repair/web/${id}`) as RepairInfo;
    } catch (e) {
    }
  }

  async getRow(row: any) {
    this.selectedRow = row;
    this.loadingImages = true;
    this.damagesDataSource.data = row.damages;
    this.specialDamagesDataSource.data = row.special_damages;
    this.sparePartsDataSource.data = row.spare_parts_used;
    this.repairedInfo = row.repairs;
    this.showExtraInfo = true;

    this.imageFileSource = [];
    this.imageRepairFileSource = [];
    for (const file of row.files) {
      const imageFile = `${environment.apiUrl}files?name=${file.file_name ? file.file_name : file.name}&model=repairs`;

      this.imageFileSource.push(imageFile);
    }


    this.loadingImages = false;
  }

  confirmCancellation(row: any, position: number) {
    const dialog = this.matDialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να ακυρώσετε την επισκευή για το ψυγείο με σειριακό αριθμό ${row.serial_number ? row.serial_number : 'ΑΝΕΥ ΣΕΙΡΙΑΚΟΫ'}?`,
        title: 'Ακύρωση εντολής επισκευής',
      }
    });

    dialog.afterClosed().subscribe(async (response) => {
      if (response) {
        await this.cancelRepairOrder({
          repair_details_id: row.id,
          repairId: this.repairId,
          serial_number: row.serial_number,
          index: position,
          material_description: row.material_description,
          material_id: row.material_id
        });
      } else {

      }
    });
  }

  openSnackBar(message: string) {
    const action = 'Κλείσιμο';
    this.matSnackBar.open(message, action, {
      duration: 2000,
    });
  }

  editSerialNumber(row: any) {
    const dialog = this.matDialog.open(EditDetailsFormComponent, {
      data: {
        type: 0,
        repairOrderId: this.repairId,
        row
      }
    });

    dialog.afterClosed().subscribe(response => {
      if (response) {
        if (response.success) {
          this.openSnackBar(`Η ενημέρωση σειριακού ολοκληρώθηκε με επιτυχία`);
          const updatedRow = response.result;
          const index = this.dataSource.filteredData.indexOf(row);
          this.dataSource.data[index].serial_number = updatedRow.serial_number;
        } else {
          this.openSnackBar(`Η ενημέρωση απέτυχε. Reason: ${response.error.message}`);
        }
      }
    });
  }

  editExpectedDate() {
    const dialog = this.matDialog.open(EditDetailsFormComponent, {
      data: {
        type: 1,
        repairOrderId: this.repairId,
        expected_date: this.repairInfo.expected_date
      }
    });

    dialog.afterClosed().subscribe(async (response) => {
      if (response) {
        if (response.success) {
          try {
            const model = {
              change_type: 'expected_date',
              initial_value: this.repairInfo.expected_date,
              changed_value: response.expected_date
            };
            await this.commonService.updateObject(`repair/web/${this.repairId}`, model);
            this.repairInfo.expected_date = new Date(response.expected_date);
            this.repairInfo.expectedDateToString = moment(this.repairInfo.expected_date).format('DD-MM-YYYY');
            this.openSnackBar(`Η ενημέρωση της ημερομηνίας ολοκληρώθηκε με επιτυχία`);
          } catch (e) {
            this.openSnackBar(`Κάτι πήγε στραβά. ${e.message}`);
          }
        }
      }
    });
  }

  editRouting() {
    const previousTechnicianId = this.repairInfo.technician_id;
    const dialog = this.matDialog.open(EditDetailsFormComponent, {
      data: {
        type: 2,
        repairOrderId: this.repairId,
        technicians: this.technicians,
        previousTechnicianId
      }
    });

    dialog.afterClosed().subscribe(async (response) => {
      if (response) {
        if (response.success) {
          try {
            if (!previousTechnicianId) {
              await this.commonService.updateObject(`repair/routing/web/${this.repairId}`,
                {technician_id: response.selectedTechnician.id, expected_date: response.expected_date});
              this.repairInfo.technician_id = response.selectedTechnician.id;
              this.repairInfo.technician_name = response.selectedTechnician.description;
              this.repairInfo.expected_date = new Date(response.expected_date);
              this.repairInfo.expectedDateToString = moment(this.repairInfo.expected_date).format('DD-MM-YYYY');
              this.openSnackBar(`Η ανάθεση ολοκληρώθηκε με επιτυχία`);
            } else {
              const model = {
                change_type: 'technician',
                initial_value: previousTechnicianId,
                changed_value: response.selectedTechnician.id
              };

              await this.commonService.updateObject(`repair/web/${this.repairId}`, model);
              this.repairInfo.technician_id = response.selectedTechnician.id;
              this.repairInfo.technician_name = response.selectedTechnician.description;
              this.openSnackBar(`Η ενημέρωση ανάθεσης ολοκληρώθηκε με επιτυχία`);
            }
          } catch (e) {
            this.openSnackBar(`Η ενημέρωση απέτυχε. Reason: ${e.message}`);
          }
        } else {
          this.openSnackBar(`Η ενημέρωση απέτυχε. Reason: ${response.error.message}`);
        }
      }
    });
  }

  async cancelRepairOrder(object) {
    try {
      const model = {
        repair_details_id: object.repair_details_id,
        change_type: 'cancel'
      };

      await this.commonService.updateObject(`repair/web/${object.repairId}`, model);
      this.openSnackBar(`Το ψυγείο με σειριακό αριθμό ${object.serial_number} ακυρώθηκε με επιτυχία`);
      const data: any = JSON.parse(JSON.stringify(this.dataSource.data));

      this.damagesDataSource.data = [];
      this.specialDamagesDataSource.data = [];
      this.sparePartsDataSource.data = [];
      this.imageFileSource = [];
      this.repairedInfo = null;

      // const tempData = data.splice(object.index, 1);

      this.dataSource.data = data;

      // If sale point and distribution center is the same don't create return command
      if (this.repairInfo.distribution_center_id !== this.repairInfo.sale_point.id) {
        const dialog = this.matDialog.open(ConfirmationDialogComponent, {
          data: {
            message: `Θέλετε να δημιουργήσετε εντολή επιστροφής για το ακυρωμένο ψυγείο?`,
            title: 'Δημιουργία εντολής επιστροφής',
          }
        });

        dialog.afterClosed().subscribe(async (response) => {
          if (response) {
            const returnModel = {
              type_id: 10,
              user_id: this.user.id,
              applicant_sale_point_id: this.repairInfo.sale_point.id,
              recipient_sale_point_id: null,
              details: [{
                serial_number: object.serial_number,
                material_id: object.material_id,
                material_description: object.material_description
              }]
            };
            await this.createReturnOrder(returnModel);
          } else {

          }
        });
      }
    } catch (e) {
      this.openSnackBar(`Κάτι πήγε στραβά. Reason: ${e.message}`);
    } finally {

    }
  }

  private async createReturnOrder(object) {
    try {
      await this.commonService.insertObject('return_command/mobile', object);
      this.openSnackBar(`Η εντολή επιστροφής δημιουργήθηκε με επιτυχία`);
    } catch (e) {
      this.openSnackBar(`Κάτι πήγε στραβά. Reason: ${e.message}`);
    }
  }

  // tslint:disable-next-line:variable-name
  getImages(): string[] {
    const imageRepairFileSource = [];
    // const repair = this.selectedRow.repairs.find(record => record.repair_details_case_id === repair_details_case_id);

    for (const repair of this.selectedRow.repairs) {
      for (const file of repair.files) {
        const imageFile = `${environment.apiUrl}files?name=${file.file_name ? file.file_name : file.name}&model=repairs`;
        imageRepairFileSource.push(imageFile);
      }
    }

    return imageRepairFileSource;
  }

  // tslint:disable-next-line:variable-name
  private async getTechnicians(distribution_center_id: number, type_id: number, category_type: number) {
    try {
      return await this.commonService.getSimpleList(`repair/technicians?distribution_center_id=${distribution_center_id}&type_id=${type_id}&category_type=${category_type}`);
    } catch (e) {
    }
  }
}
